import React from 'react';
import { Box, Typography, Link, Grid, Paper, Card, CardContent, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import HousePhoto from '../components/HousePhotos'; // Import house photo

const About = () => {
  const { t } = useTranslation(); // Initialize translation hook

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '90vh',
        padding: 2,
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 1200, // Large card width
          boxShadow: 3,
          borderRadius: 2,
          padding: 4,
        }}
      >
        <CardContent>
          <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', marginBottom: 4 }}>
            {t("About.about_us")}
          </Typography>

          <section style={{ marginBottom: '40px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
              {t("About.meet_our_family")}
            </Typography>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ width: '100%' }}> {/* 3:4 aspect ratio container */}
                  <img
                    src="/images/max.jpg"
                    alt="Max"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', // Or 'contain' if you want to avoid cropping
                    }}
                  />
                </Box>
                <Paper sx={{ padding: '20px', boxShadow: 3, width: '93%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{t("About.teacher_max")}</Typography>
                  <Typography variant="body1">
                    <strong>{t("About.experience")}:</strong> {t("About.max_experience")}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ width: '100%' }}> {/* 3:4 aspect ratio container */}
                  <img
                    src="/images/kung.jpg"
                    alt="Kung"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', // Or 'contain'
                    }}
                  />
                </Box>
                <Paper sx={{ padding: '20px', boxShadow: 3, width: '93%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{t("About.teacher_kung")}</Typography>
                  <Typography variant="body1">
                    <strong>{t("About.experience")}:</strong> {t("About.kung_experience")}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </section>

          <Divider sx={{ marginBottom: 4 }} />

          <section style={{ marginBottom: '40px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
              {t("About.our_location")}
            </Typography>
            <HousePhoto />
            <Typography variant="body1" sx={{ marginBottom: '20px' }}>
              {t("About.location_description")}
            </Typography>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3757.594377671478!2d99.4860169117325!3d19.644631681604093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30d74177f59597cb%3A0xc900dd61071aa549!2sAgape%20to%20the%20Max!5e0!3m2!1sen!2sth!4v1736777103323!5m2!1sen!2sth"
              width="100%"
              height="450"
              style={{ border: '0' }}
              allowFullScreen=""
              loading="lazy"
              title='Google Maps: Agape to the Max'
            />
          </section>

          <Divider sx={{ marginBottom: 4 }} />

          <section style={{ marginBottom: '40px' }}>
            <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
              {t("About.about_the_school")}
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: '20px' }}>
              {t("About.school_description")}
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: '20px' }}>
              {t("About.school_location")}
            </Typography>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d558.5396150779163!2d99.5051233869399!3d19.653288254753612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDM5JzEyLjEiTiA5OcKwMzAnMTkuNSJF!5e0!3m2!1sen!2sth!4v1736349919984!5m2!1sen!2sth"
              width="100%"
              height="450"
              style={{ border: '0' }}
              allowFullScreen=""
              loading="lazy"
              title='Google Maps: Siri Santisuk Wittaya'
            />
            <Typography variant="body1" sx={{ marginTop: '20px' }}>
              {t("About.learn_more")} <Link href="https://www.facebook.com/SirisantisukWitthaya" target="_blank" rel="noopener noreferrer">{t("About.facebook_page")}</Link>.
            </Typography>
          </section>
        </CardContent>
      </Card>
    </Box>
  );
};

export default About;
